import { Box, Typography } from '@mui/material';
import Switch from 'components/formik/Switch';
import { connect, Field } from 'formik';
import { object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const InviteSwitch = ({ formik }) => (
  <Box sx={{ justifySelf: 'flex-start', display: 'flex', alignItems: 'center' }}>
    <Field component={Switch} label="" disabled={formik.values.inviteDisabled} name="invite" />
    <div>
      <Typography variant="subtitle1">{I18n.t('EmployeeDrawer.InviteSwitch.label')}</Typography>
      <Typography variant="caption">{I18n.t('EmployeeDrawer.InviteSwitch.caption')}</Typography>
    </div>
  </Box>
);
InviteSwitch.propTypes = {
  formik: object.isRequired,
};

export default connect(InviteSwitch);
